import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';
import classnames from 'classnames';
import Lib from '../../commons/lib';
import CimKezeles from './CimKezeles';
import HirlevelKezeles from './HirlevelKezeles';
import KategoriaKezeles from './KategoriaKezeles';
import LeiratkozasTorzs from './LeiratkozasTorzs';
import CustomTooltip from '../../components/Tooltip/CustomTooltip';
import getTooltip from './HirlevelTooltips';

class HirlevelBase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: undefined,
      type: 'HIRLEVEL'
    };
  }

  componentDidMount() {
    this.initTab();
  }

  initTab = () => {
    let activeTab = undefined;
    if (this.props.globals.hasRole(['HIRLEVEL_HIRLEVEL'])) activeTab = '1';
    this.setState({ activeTab: activeTab });
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  render() {
    let cardStyle = {
      padding: 10
    };

    return (
      <div>
        <div className="animated fadeIn">
          <div className="card">
            <div className="card-header">
              Hírlevélkezelés
              {/* <YouTube data={videoData} /> */}
            </div>
            <div className="row" style={cardStyle}>
              <div className="col-md-12">
                <Nav tabs>
                  <NavItem>
                    <NavLink
                      href="#"
                      className={classnames({ active: this.state.activeTab === '1' })}
                      onClick={() => { this.toggle('1'); }}
                    >
                      Hírlevél
                      <CustomTooltip text={getTooltip('hirlevel')} id="hirlevelTT" />
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      href="#"
                      className={classnames({ active: this.state.activeTab === '2' })}
                      onClick={() => { this.toggle('2'); }}
                    >
                      Feliratkozók
                      <CustomTooltip text={getTooltip('feliratkozok')} id="feliratkozokTT" />
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      href="#"
                      className={classnames({ active: this.state.activeTab === '3' })}
                      onClick={() => { this.toggle('3'); }}
                    >
                      Kategóriák
                      <CustomTooltip text={getTooltip('kategoriak')} id="kategoriakTT" />
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      href="#"
                      className={classnames({ active: this.state.activeTab === '4' })}
                      onClick={() => { this.toggle('4'); }}
                    >
                      Leiratkozás indok
                      <CustomTooltip text={getTooltip('leiratkozasindok')} id="leiratkozasindokTT" />
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                  <TabPane tabId="1">
                    <HirlevelKezeles {...this.props} globals={this.props.globals} type={this.state.type} active={this.state.activeTab === '1'}/>
                  </TabPane>
                  <TabPane tabId="2">
                    <CimKezeles {...this.props} globals={this.props.globals} type={this.state.type} active={this.state.activeTab === '2'}/>
                  </TabPane>
                  <TabPane tabId="3">
                    <KategoriaKezeles {...this.props} globals={this.props.globals} type={this.state.type} active={this.state.activeTab === '3'}/>
                  </TabPane>
                  <TabPane tabId="4">
                    <LeiratkozasTorzs {...this.props} globals={this.props.globals} type={this.state.type} active={this.state.activeTab === '4'}/>
                  </TabPane>
                </TabContent>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

HirlevelBase.propTypes = {
  route: PropTypes.object,
  globals: PropTypes.object
};

export default HirlevelBase;
